import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { UserRole } from '../interfaces/login.interface';

export const RoleGuard: CanMatchFn = (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.authStatus() !== 'authenticated') {
    return router.createUrlTree(['/auth/login']);
  }

  const role = authService.userLogin()?.role;
  const allowedRoles = (route.data?.['roles'] as UserRole[]) ?? [];

  if (allowedRoles.length === 0) {
    return router.createUrlTree(['/veflo-vault/chat']);
  }

  const hasAccess = !!role && allowedRoles.includes(role);
  return hasAccess ? true : router.createUrlTree(['/veflo-vault/chat']);
};
